import React from 'react';
import { OrganizationList } from './organization-list';
import { useIsSmallScreen } from '../../system/SystemMediaQueriesProvider';

export function OrganizationMain() {
  const isSmall = useIsSmallScreen();

  return (
    <div
      style={{
        margin: isSmall ? '0px' : '10px',
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
        alignItems: 'stretch',
      }}
    >
      <OrganizationList />
    </div>
  );
}
